import type { SilobagRow } from '@siloreal:modules:private/silobag-list/config/extra/types';
import {
  listArchivedSilobagsService,
  type SilobagArchivedListItem,
  type SilobagArchivedListServiceContract,
} from '@siloreal:shared:api/service/silobag/silobag-archived-list';
import type { SilobagListResponse } from '@siloreal:shared:api/service/silobag/silobag-list';
import * as UI from '@siloreal:shared:ui';
import { useSilobagListContext } from '../../../context';
import { TABLE_INTERACTIONS } from '../interactions';
import { TABLE_COLUMNS, TABLE_PINNED_COLUMNS } from '../table-columns';

const TABLE_ROW_STYLE_VARIANT: UI.TableProps['getRowStyleVariant'] = () => 'none';

function toExplorerRow(item: SilobagArchivedListItem): SilobagRow {
  return {
    id: item.id,
    name: item.silobag_name,
    bagging_date: item.bagging_date,
    input_weight: item.input_weight,
    silobag_species_types: {
      id: item.silobag_species_type_id,
      name: item.silobag_species_type_name,
    },
    silobag_harvests: item.silobag_harvest_id
      ? { id: item.silobag_harvest_id, name: item.silobag_harvest_name ?? '' }
      : null,
    lots: {
      countrysides: { name: item.countryside_name },
    },
    organizations: { name: item.organization_name },
    tags_silobags: [],
    write_permission: item.write_permission,
  } as unknown as SilobagRow;
}

export function ExplorerArchivedSilobag() {
  const {
    organization: { current: organizationId },
    async: {
      list: { update },
    },
  } = useSilobagListContext();

  return (
    <UI.collection.explorer
      service={{
        fn: listArchivedSilobagsService,
        key: ['silobag-archived-list', organizationId],
        adapter: (): SilobagArchivedListServiceContract => ({
          query: { organization_id: organizationId },
        }),
        callback: {
          onSuccess: (result) => update(result.original as unknown as SilobagListResponse),
          dataAccess: (data) => data.data.map(toExplorerRow) as UI.TableProps['rows'],
          rowCountAccess: (data) => data.totalFilteredSilobags,
        },
      }}
      columns={TABLE_COLUMNS.SILOBAG.ARCHIVED}
      headerAction={TABLE_INTERACTIONS.SILOBAG.ARCHIVED}
      pinnedColumns={TABLE_PINNED_COLUMNS}
      getRowStyleVariant={TABLE_ROW_STYLE_VARIANT}
      tidPrefix="silobag-archived-list"
    >
      {/* {TABLE_FILTERS.SILOBAG.ARCHIVED} */}
    </UI.collection.explorer>
  );
}
